import { fetchApi } from "../components/FetchApi";
import { wrapServiceCall } from "./ServiceUtils";

export const getConsent = (sessionId = null) => {
  const params = sessionId ? `?sessionId=${encodeURIComponent(sessionId)}` : "";
  return wrapServiceCall(() =>
    fetchApi(`/cookie-consent${params}`, { method: "GET" })
  );
};

export const saveConsent = (consent, sessionId = null) => {
  const params = sessionId ? `?sessionId=${encodeURIComponent(sessionId)}` : "";
  return wrapServiceCall(() =>
    fetchApi(`/cookie-consent${params}`, {
      method: "POST",
      body: JSON.stringify(consent)
    })
  );
};

export const deleteConsent = (sessionId = null) => {
  const params = sessionId ? `?sessionId=${encodeURIComponent(sessionId)}` : "";
  return wrapServiceCall(() =>
    fetchApi(`/cookie-consent${params}`, { method: "DELETE" })
  );
};

